import { createBreakpoints } from '@mui/system';
var breakpoints = createBreakpoints({});
export var StepIconTheme = function (theme) {
    var _a, _b;
    return ({
        defaultProps: {},
        styleOverrides: {
            root: (_a = {
                    fontSize: theme.typography.h1.fontSize
                },
                _a[breakpoints.down('sm')] = {
                    fontSize: "1.5rem", //24
                },
                _a['&:not(.Mui-active)&:not(.Mui-completed)'] = {
                    borderRadius: "100%",
                    border: "1px solid ".concat(theme.palette.greySecondary[600]),
                    circle: {
                        fill: theme.palette.greySecondary.contrastText,
                    },
                    text: {
                        fill: theme.palette.text.secondary,
                    },
                },
                _a['&.Mui-completed'] = {
                    color: theme.palette.success.main,
                },
                _a),
            text: (_b = {
                    fontSize: theme.typography.body1.fontSize
                },
                _b[breakpoints.down('sm')] = {
                    fontSize: "0.813rem", //13
                },
                _b.fontWeight = 'bold',
                _b.fontFamily = "Noto Sans KR, -apple-system , Malgun Gothic, sans-serif , Apple SD Gothic Neo",
                _b.transform = "translateY(-1px)",
                _b),
        },
    });
};
export default StepIconTheme;
//# sourceMappingURL=theme.js.map